module.exports = "<header>\r\n  <h1>{{ titleService.getTitle() }}</h1>\r\n</header>\r\n\r\n<main>\r\n</main>\r\n\r\n<footer>\r\n</footer>\r\n"